import React from "react";

type IntegrationHeaderProps = {
    integrationType: string;
};

export const IntegrationHeader = ({
    integrationType,
}: IntegrationHeaderProps) => {
    switch (integrationType) {
        case "googleSheet":
            return (
                <>
                    <div className="flex items-center gap-1">
                        <img
                            src="/google_sheet.png"
                            alt="google_sheet"
                            className=" w-[14px] -mt-1 "
                        />
                        <span className="text-sm font-semibold leading-none tracking-tight ">
                            Google Sheet Integration
                        </span>
                    </div>
                    <div className="text-xs text-muted-foreground">
                        Send your data straight to Google Sheets. Automatically
                        syncs as results come in.
                    </div>
                </>
            );
        default:
            return (
                <div className="flex items-center gap-1">
                    <span className=" text-[14px]">Integration</span>
                </div>
            );
    }
};
